import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const SectionHero = ({ title1, titleAccent, title2, description }) => (
  <section className="relative bg-gradient-to-br from-gray-900 to-gray-800 text-white py-32 mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          {title1} <span className="text-orange-500">{titleAccent}</span> {title2}
        </h1>
        <p className="text-xl text-gray-300">{description}</p>
      </div>
    </div>
  </section>
);

const SectionCTA = ({ title, description, buttonText, buttonLink, testId }) => (
  <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-4xl md:text-5xl font-bold mb-6">{title}</h2>
      <p className="text-xl text-gray-300 mb-8">{description}</p>
      <Link to={buttonLink}>
        <Button data-testid={testId} className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 hover:shadow-2xl hover:scale-105">
          {buttonText}
        </Button>
      </Link>
    </div>
  </section>
);

const SectionHeading = ({ title, titleAccent, subtitle }) => (
  <div className="text-center mb-16">
    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
      {title} <span className="text-orange-500">{titleAccent}</span>
    </h2>
    {subtitle && <p className="text-xl text-gray-600 max-w-3xl mx-auto">{subtitle}</p>}
  </div>
);

const ServiceCard = ({ icon: Icon, title, description, features, keyFeaturesLabel }) => (
  <div className="group hover:shadow-2xl transition-all duration-500 border-0 overflow-hidden bg-white rounded-lg shadow">
    <div className="p-6">
      <div className="bg-gradient-to-br from-orange-500 to-orange-600 w-16 h-16 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
        <Icon className="h-8 w-8 text-white" />
      </div>
      <h3 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h3>
    </div>
    <div className="px-6 pb-6">
      <p className="text-gray-600 mb-6">{description}</p>
      <div className="space-y-2">
        <h4 className="font-semibold text-gray-900 text-sm">{keyFeaturesLabel}</h4>
        <ul className="space-y-2">
          {features.map((feature) => (
            <li key={feature} className="flex items-center space-x-2 text-sm text-gray-600">
              <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export { SectionHero, SectionCTA, SectionHeading, ServiceCard };
